export const FEATURES = Object.freeze({
  ADMIN_MODULE: true,
});

export const isAdminUser = (user) => {
  const roles = Array.isArray(user?.roles)
    ? user.roles
    : user?.role
    ? [user.role]
    : [];
  return roles.some((role) => String(role).toUpperCase() === "ADMIN");
};

export const isAdminModuleEnabled = (user) =>
  FEATURES.ADMIN_MODULE && isAdminUser(user);
